import { render, staticRenderFns } from "./Recount__plotsRel.vue?vue&type=template&id=b52f1972&scoped=true&"
import script from "./Recount__plotsRel.vue?vue&type=script&lang=js&"
export * from "./Recount__plotsRel.vue?vue&type=script&lang=js&"
import style0 from "./Recount__plotsRel.vue?vue&type=style&index=0&id=b52f1972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52f1972",
  null
  
)

export default component.exports